


const StarCircle = ({ color, className }) => {

    return (
        <svg  className={className} xmlns="http://www.w3.org/2000/svg" width="81" height="82" viewBox="0 0 81 82" fill="none">
            <path d="M60.7518 6.25L63.0587 12.6406L69.813 13.3758L70.226 20.1575L76.4996 22.7659L74.9853 29.3892L80.2699 33.6594L76.9509 39.5877L80.8184 45.1738L75.9636 49.927L78.1007 56.3764L72.1035 59.5693L72.3369 66.3595L65.6831 67.7334L63.9941 74.3144L57.2227 73.7581L53.748 79.5966L47.4076 77.1551L42.4288 81.7782L37.0331 77.6493L30.9535 80.6824L26.9396 75.2006L20.2518 76.3981L17.9448 70.0075L11.1905 69.2722L10.7775 62.4906L4.50393 59.8822L6.01821 53.2589L0.733651 48.9887L4.05259 43.0603L0.185149 37.4743L5.03987 32.7211L2.90286 26.2717L8.90006 23.0788L8.66661 16.2886L15.3204 14.9146L17.0095 8.3337L23.7808 8.88998L27.2555 3.05149L33.5959 5.49296L38.5747 0.869903L43.9704 4.99876L50.05 1.96566L54.0639 7.44742L60.7518 6.25Z" fill={color} />
        </svg>
    )
}
export default StarCircle;